import { Injectable } from '@angular/core';
import { SendShippingEmailRequest, ShippingAccounting } from '../../domain/entities/shipping-accounting.entity';
import { SendShippingEmailDto, ShippingAccountingDto } from '../dtos/shipping-accounting.dto';

@Injectable()
export class ShippingAccountingMapper {
  fromDto(dto: ShippingAccountingDto): ShippingAccounting {
    return {
      professionalId: String(dto.professionalId),
      professionalName: dto.professionalName,
      email: dto.userEmail,
      quantitySent: dto.quantityEmailSent ?? 0,
      quantityPending: dto.quantityAwaitingEmailSending ?? 0,
    };
  }

  toSendEmailDto(request: SendShippingEmailRequest): SendShippingEmailDto {
    return {
      professional: request.professionalIri,
      mailTo: request.email,
      startDate: `${request.startDate}T00:00:00-03:00`,
      endDate: `${request.endDate}T23:59:59-03:00`,
      onlyPending: request.onlyPending,
    };
  }
}
